// Assisted Scanning
import assistedLandingPageImage from '@volumental/assets/images/scanner/assisted/onboarding/2shot_landing.png';
import assistedHandOverPhone from '@volumental/assets/images/scanner/assisted/onboarding/hand_over_phone.png';
import assistedC1InstructionImage from '@volumental/assets/images/scanner/assisted/onboarding/phone_angle.png';
import assistedRollUpPantsImage from '@volumental/assets/images/scanner/assisted/onboarding/roll_up.png';
import assistedTakeOfShoesImage from '@volumental/assets/images/scanner/assisted/onboarding/take_off_shoes.png';
import assistedPoseImage1 from '@volumental/assets/images/scanner/assisted/poseInstructions/pose1.png';
import assistedPoseImage2 from '@volumental/assets/images/scanner/assisted/poseInstructions/pose2.png';
// Solo Scanning
import soloLandingPageImage from '@volumental/assets/images/scanner/chachaStep/onboarding/2shot_landing.png';
import soloPlacePaperImage from '@volumental/assets/images/scanner/chachaStep/onboarding/place_paper.png';
import soloRollUpPantsImage from '@volumental/assets/images/scanner/chachaStep/onboarding/roll_up.png';
import soloTakeOfShoesImage from '@volumental/assets/images/scanner/chachaStep/onboarding/take_off_shoes.png';
import soloPoseImage1 from '@volumental/assets/images/scanner/chachaStep/poseInstructions/pose1.png';
import soloPoseImage2 from '@volumental/assets/images/scanner/chachaStep/poseInstructions/pose2.png';
import { useCallback } from 'react';
import { ScannerVariant } from '../pages/scanner/utils';

export enum ImageNames {
  PoseImage1 = 'poseImage1',
  PoseImage2 = 'poseImage2',
  FirstCaptureInstructionImage = 'firstCaptureInstructionImage',
  PlacePaperImage = 'placePaperImage',
  RollUpPantsImage = 'rollUpPantsImage',
  TakeOfShoesImage = 'takeOfShoesImage',
  LandingPageImage = 'landingPageImage',
  HandOverPhone = 'handOverPhone',
  CapturingInstruction = 'capturingInstruction',
}
const assisted = {
  poseImage1: assistedPoseImage1,
  poseImage2: assistedPoseImage2,
  firstCaptureInstructionImage: assistedC1InstructionImage,
  placePaperImage: soloPlacePaperImage,
  rollUpPantsImage: assistedRollUpPantsImage,
  takeOfShoesImage: assistedTakeOfShoesImage,
  landingPageImage: assistedLandingPageImage,
};
const solo = {
  poseImage1: soloPoseImage1,
  poseImage2: soloPoseImage2,
  firstCaptureInstructionImage: assistedC1InstructionImage,
  placePaperImage: soloPlacePaperImage,
  rollUpPantsImage: soloRollUpPantsImage,
  takeOfShoesImage: soloTakeOfShoesImage,
  landingPageImage: soloLandingPageImage,
};

export const useImageSrc = (
  variant: ScannerVariant,
): ((image: ImageNames) => string) => {
  const imageList = variant === ScannerVariant.Assisted ? assisted : solo;
  return useCallback(
    (image: ImageNames) => {
      switch (image) {
        case ImageNames.PoseImage1: {
          return imageList.poseImage1;
        }

        case ImageNames.PoseImage2: {
          return imageList.poseImage2;
        }

        case ImageNames.FirstCaptureInstructionImage: {
          return imageList.firstCaptureInstructionImage;
        }

        case ImageNames.PlacePaperImage: {
          return imageList.placePaperImage;
        }

        case ImageNames.RollUpPantsImage: {
          return imageList.rollUpPantsImage;
        }

        case ImageNames.TakeOfShoesImage: {
          return imageList.takeOfShoesImage;
        }

        case ImageNames.LandingPageImage: {
          return imageList.landingPageImage;
        }

        case ImageNames.HandOverPhone: {
          return assistedHandOverPhone;
        }

        default: {
          return soloLandingPageImage;
        }
      }
    },
    [imageList],
  );
};
